module.exports = __webpack_public_path__ + "static/flags/SE-86a6b400de8ab387c1adc6213e335ed2.gif";